module.exports = __webpack_public_path__ + "img/17.3863fdb3.jpg";